/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * Print Type Selector - Grid layout for print technology selection
 * Updated: 2026-01-10
 */

import React from 'react';
import { Zap, Palette } from 'lucide-react';

interface PrintTypeSelectorProps {
  printType: 'laser' | 'silk';
  onChange: (type: 'laser' | 'silk') => void;
  disabled?: boolean;
}

const PrintTypeSelector: React.FC<PrintTypeSelectorProps> = ({
  printType,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="bg-white rounded-lg p-2 lg:p-5 shadow-sm border border-[#eee] flex-shrink-0">
      <h3 className="text-[11px] lg:text-base font-bold text-[#333333] mb-2 lg:mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>2. CÔNG NGHỆ IN</h3>

      {/* Grid Layout - 1 column (silk option hidden) */}
      <div className="grid grid-cols-1 gap-2 lg:gap-3">
        {/* Laser Option */}
        <button
          onClick={() => !disabled && onChange('laser')}
          disabled={disabled}
          className={`flex flex-col items-center gap-1.5 p-2 lg:p-3 rounded-md transition-all border-2 ${
            printType === 'laser'
              ? 'border-[rgb(6,182,212)] bg-white shadow-md shadow-[rgb(6,182,212)]/20'
              : 'border-[#eee] bg-white hover:border-[#ddd]'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          {/* Title */}
          <p className={`text-[8px] lg:text-sm font-bold text-center ${printType === 'laser' ? 'text-[rgb(6,182,212)]' : 'text-[#333333]'}`} style={{ fontFamily: 'Oswald, sans-serif' }}>
            KHẮC LASER
          </p>

          {/* Description */}
          <p className="text-[7px] lg:text-xs text-[#999] text-center" style={{ fontFamily: 'Quicksand, sans-serif' }}>
            Hình ảnh đơn sắc
          </p>
        </button>

        {/* Silk Print Option - HIDDEN */}
        {/* <button
          onClick={() => !disabled && onChange('silk')}
          disabled={disabled}
          className={`flex flex-col items-center gap-1.5 p-2 lg:p-3 rounded-md transition-all border-2 ${
            printType === 'silk'
              ? 'border-[rgb(6,182,212)] bg-white shadow-md shadow-[rgb(6,182,212)]/20'
              : 'border-[#eee] bg-white hover:border-[#ddd]'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <p className={`text-[8px] lg:text-sm font-bold text-center ${printType === 'silk' ? 'text-[rgb(6,182,212)]' : 'text-[#333333]'}`} style={{ fontFamily: 'Oswald, sans-serif' }}>
            IN LỤA
          </p>
          <p className="text-[7px] lg:text-xs text-[#999] text-center" style={{ fontFamily: 'Quicksand, sans-serif' }}>
            Đầy đủ màu sắc
          </p>
        </button> */}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Quicksand:wght@300;400;500;600;700&display=swap');
      `}</style>
    </div>
  );
};

export default PrintTypeSelector;
